// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"354":"15a6a52ac6ceeb35768d","464":"995568fbc0cabb652530","838":"c16adeec2c10ab9f7382"}[chunkId] + ".js";
};